import { render, staticRenderFns } from "./feedbackModal.vue?vue&type=template&id=58b82ca8&scoped=true&"
import script from "./feedbackModal.vue?vue&type=script&lang=js&"
export * from "./feedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./feedbackModal.vue?vue&type=style&index=0&id=58b82ca8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b82ca8",
  null
  
)

export default component.exports